import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Route, Routes } from 'react-router-dom';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import Layout from './containers/Layout';
import LandingPage from './containers/LandingPage';
import BillingAddressPage from './containers/BillingAddressPage';
import PaymentPage from './containers/PaymentPage';
import PaymentErrorPage from './containers/PaymentErrorPage';
import PaymentCompletePage from './containers/PaymentCompletePage';
import PaymentExpiredPage from './containers/PaymentExpiredPage';
import { History } from 'history';
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles';

declare global {
    interface Window {
        __appSettings: any
    }
}

var reactPlugin = new ReactPlugin();

let theme = createTheme({
    palette: {
        primary: {
            main: '#f76c6c',
            contrastText: '#fff'
        },
        secondary: {
            main: '#114b5f'
        },
    },
    typography:
    {
        h2:
        {
            color: '#114b5f',
        },
        h4: {
            textTransform: 'uppercase',
            fontWeight: 700,
            color: '#114b5f',
            fontSize: '16px',
            lineHeight: '24px'
        },
        h6: {
            fontWeight: 'normal',
        }
    }
});
theme = responsiveFontSizes(theme);

type State = {
    applicationInsights?: ApplicationInsights
}

const defaultState: State = {};

type AppProps = {
    history: History;
};

function App(props: AppProps) {
    const [state, setState] = React.useState(defaultState);

    React.useEffect(() => {
        if (state.applicationInsights)
            return;

        const applicationInsights = new ApplicationInsights({
            config: {
                instrumentationKey: window.__appSettings.applicationInsightsInstrumentationKey,
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: { history: props.history }
                }
            }
        });
        applicationInsights.loadAppInsights();
        setState({ applicationInsights });
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <Layout>
                <CssBaseline />
                <Routes>
                    <Route path=":paymentId" element={<BillingAddressPage />} />
                    <Route path=":paymentId/address" element={<BillingAddressPage />} />
                    <Route path=":paymentId/payment" element={<PaymentPage />} />
                    <Route path=":paymentId/payment/error" element={<PaymentErrorPage />} />
                    <Route path=":paymentId/payment/complete" element={<PaymentCompletePage />} />
                    <Route path=":paymentId/payment/expired" element={<PaymentExpiredPage />} />
                    <Route path="*" element={<LandingPage />} />
                </Routes>
            </Layout>
        </ThemeProvider>
    );
}

export default withAITracking(reactPlugin, App);
